import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import Spinner from "../spinner/spinner.component";
import HallMap from "../hallmap/hallmap.component";

class ReservationStep1 extends Component {
    roomName = () => {
        if(this.props.hallConfiguration && this.props.hallConfiguration.room){
            return this.props.hallConfiguration.room.name
        }
    }
    render() {
        return (
            <Fragment>
                {this.props.loading !== 0 ? <Spinner /> : ''}

                { 
                    this.props.hallConfiguration ? 
                        <div className="step-1 text-center">
                            <span className="modal-choose-txt">ALEGE LOCUL</span>
                            <div className="screen">
                                <br />
                                <span className="modal-choose-txt">Ecran {this.roomName()}</span>
                            </div>
                            <div className="row">
                                <HallMap />
                            </div>
                        </div> :
                        '' 
                }
                
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    movie: state.movies.movieDetails,
    hallConfiguration: state.movieTheaters.hallConfiguration,
});
export default connect(mapStateToProps, {})(ReservationStep1);









// WEBPACK FOOTER //
// ./src/SHARED/components/modalreservation/reservationstep1.component.js